import { REG_EX_EMAIL } from 'constants/Constants';

export const SEND_TIME_MODE = {
    IMMEDIATELY: 'immediately',
    SCHEDULED: 'scheduled',
};

export function getScheduleDate(value) {
    const rawValue =
        value && typeof value === 'object' && !(value instanceof Date)
            ? value.valid === false
                ? null
                : value.time
            : value;

    if (!rawValue) {
        return null;
    }

    const date = new Date(rawValue);

    return Number.isNaN(date.getTime()) ? null : date;
}

export function serializeScheduleAt(value) {
    const date = getScheduleDate(value);

    return date ? date.toISOString() : null;
}

export function getAdditionalSettingsPayload({
    replyTo,
    scheduleAt,
    sendTimeMode,
    useDifferentReplyTo,
}) {
    return {
        replyTo: useDifferentReplyTo ? (replyTo || '').trim() : '',
        scheduleAt:
            sendTimeMode === SEND_TIME_MODE.SCHEDULED ? serializeScheduleAt(scheduleAt) : null,
    };
}

export function createAdditionalSettingsSnapshot(settings) {
    return {
        replyTo: settings.replyTo || '',
        scheduleAt: getScheduleDate(settings.scheduleAt),
        sendTimeMode: settings.sendTimeMode || SEND_TIME_MODE.IMMEDIATELY,
        useDifferentReplyTo: Boolean(settings.useDifferentReplyTo),
    };
}

export function restoreAdditionalSettingsSnapshot(snapshot) {
    return createAdditionalSettingsSnapshot(snapshot);
}

export function getCampaignAdditionalSettings(campaign = {}) {
    const replyTo = typeof campaign.replyTo === 'string' ? campaign.replyTo.trim() : '';
    const scheduleAt = getScheduleDate(campaign.scheduleAt);

    return {
        replyTo,
        scheduleAt,
        sendTimeMode: scheduleAt ? SEND_TIME_MODE.SCHEDULED : SEND_TIME_MODE.IMMEDIATELY,
        useDifferentReplyTo: Boolean(replyTo),
    };
}

export function isFutureSchedule(value, now = new Date()) {
    const scheduleAt = getScheduleDate(value);

    return Boolean(scheduleAt && scheduleAt.getTime() > now.getTime());
}

export function getAdditionalSettingsErrorCodes({
    replyTo,
    scheduleAt,
    sendTimeMode,
    useDifferentReplyTo,
    now,
}) {
    const errors = {};
    const normalizedReplyTo = (replyTo || '').trim();
    const emailRegex = new RegExp(REG_EX_EMAIL.source, 'i');

    if (useDifferentReplyTo) {
        if (!normalizedReplyTo) {
            errors.replyTo = 'required';
        } else if (!emailRegex.test(normalizedReplyTo)) {
            errors.replyTo = 'invalid';
        }
    }

    if (sendTimeMode === SEND_TIME_MODE.SCHEDULED && !isFutureSchedule(scheduleAt, now)) {
        errors.scheduleAt = 'invalid';
    }

    return errors;
}
